import React, { useState, useEffect } from "react";
import "./Slideshow.scss";

const Slideshow = ({ interval = 3000, className, CLOUDFRONT_URL }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const createImgSource = (
    imageName,
    sourceName
  ) => `${CLOUDFRONT_URL}/about-images/slideshow-images/${sourceName}-sat-images/slideshow_mb/${imageName} 99w,
${CLOUDFRONT_URL}/about-images/slideshow-images/${sourceName}-sat-images/slideshow_lmb/${imageName} 155w,
${CLOUDFRONT_URL}/about-images/slideshow-images/${sourceName}-sat-images/slideshow_stb/${imageName} 191w,
${CLOUDFRONT_URL}/about-images/slideshow-images/${sourceName}-sat-images/slideshow_tb/${imageName} 239w,
${CLOUDFRONT_URL}/about-images/slideshow-images/${sourceName}-sat-images/slideshow_sm/${imageName} 259w,
${CLOUDFRONT_URL}/about-images/slideshow-images/${sourceName}-sat-images/slideshow_md/${imageName} 419w,
${CLOUDFRONT_URL}/about-images/slideshow-images/${sourceName}-sat-images/slideshow_lg/${imageName} 489w`;

  const images = [
    { imageName: "web-hum-1.png", sourceName: "hum" },
    { imageName: "web-usgs-1.jpg", sourceName: "usgs" },
    { imageName: "web-hum-2.png", sourceName: "hum" },
    { imageName: "web-usgs-2.jpg", sourceName: "usgs" },
    { imageName: "web-hum-3.png", sourceName: "hum" },
    { imageName: "web-usgs-3.jpg", sourceName: "usgs" },
    { imageName: "web-hum-4.png", sourceName: "hum" },
    { imageName: "web-usgs-4.jpg", sourceName: "usgs" },
    { imageName: "web-hum-5.png", sourceName: "hum" },
    { imageName: "web-usgs-5.jpg", sourceName: "usgs" },
    { imageName: "web-hum-6.png", sourceName: "hum" },
    { imageName: "web-usgs-6.jpg", sourceName: "usgs" },
    { imageName: "web-hum-7.png", sourceName: "hum" },
    { imageName: "web-usgs-7.jpg", sourceName: "usgs" },
    { imageName: "web-hum-8.png", sourceName: "hum" },
    { imageName: "web-usgs-8.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-9.jpg", sourceName: "usgs" },
    { imageName: "web-hum-10.png", sourceName: "hum" },
    { imageName: "web-usgs-10.jpg", sourceName: "usgs" },
    { imageName: "web-hum-11.png", sourceName: "hum" },
    { imageName: "web-usgs-11.jpg", sourceName: "usgs" },
    { imageName: "web-hum-12.png", sourceName: "hum" },
    { imageName: "web-usgs-12.jpg", sourceName: "usgs" },
    { imageName: "web-hum-13.png", sourceName: "hum" },
    { imageName: "web-usgs-13.jpg", sourceName: "usgs" },
    { imageName: "web-hum-14.png", sourceName: "hum" },
    { imageName: "web-usgs-14.jpg", sourceName: "usgs" },
    { imageName: "web-hum-15.png", sourceName: "hum" },
    { imageName: "web-usgs-15.jpg", sourceName: "usgs" },
    { imageName: "web-hum-16.png", sourceName: "hum" },
    { imageName: "web-usgs-16.jpg", sourceName: "usgs" },
    { imageName: "web-hum-17.png", sourceName: "hum" },
    { imageName: "web-usgs-17.jpg", sourceName: "usgs" },
    { imageName: "web-hum-18.png", sourceName: "hum" },
    { imageName: "web-usgs-18.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-19.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-20.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-21.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-22.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-23.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-24.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-25.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-26.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-27.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-28.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-29.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-30.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-31.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-32.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-33.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-34.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-35.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-36.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-37.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-38.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-39.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-40.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-41.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-42.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-43.jpg", sourceName: "usgs" },
    { imageName: "web-usgs-44.jpg", sourceName: "usgs" },
  ];

  images.forEach((image) => {
    image.imageSourceSet = createImgSource(image.imageName, image.sourceName);
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, interval);

    return () => clearInterval(timer);
  }, [images.length, interval]);

  return (
    <div className={`slideshow ${className || ""}`}>
      {images.map((image, index) => (
        <img
          key={index}
          srcSet={image.imageSourceSet}
          sizes="(max-width: 424px) 99px,
       (max-width: 575px) 155px,
       (max-width: 767px) 191px,
       (max-width: 1023px) 239px,
       (max-width: 1439px) 259px,
       (max-width: 1919px) 419px,
       489px"
          alt={`Slideshow image ${index + 1}, Photo by <a  target="_blank" href="https://unsplash.com/@usgs?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">USGS</a> on <a  target="_blank" href="https://unsplash.com/photos/satellite-imagery-of-a-glacier-UrMGQNrkdO0?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
      `}
          className={`slideshow__image ${
            index === currentIndex ? "slideshow__image--active" : ""
          }`}
        />
      ))}
    </div>
  );
};

export default Slideshow;
